import { ReactNode } from 'react';

import warningCircle from './warning-circle.svg';
import classes from './StatusMessage.module.scss';

interface StatusMessageProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  // replaces the default warning icon
  icon?: ReactNode;
}

const StatusMessage = ({ title, description, action, icon }: StatusMessageProps): JSX.Element => (
  <div className={classes.statusMessage}>
    {icon ?? <img className="icon" src={warningCircle} alt="" aria-hidden="true" />}
    <h2 className="title">{title}</h2>
    {description && <p className="description">{description}</p>}
    {action && <div className="action">{action}</div>}
  </div>
);

export default StatusMessage;
